export default __webpack_public_path__ + "fed6c16d7d57e7757a42cc63c4e7b64d.png";